export const formatTitle = (title) => {
  if (title) {
    return title
      .replace(new RegExp(/[0-9]+\W/), "")
      .replace(new RegExp(/(\*)+/g), "")
      .trim();
  }
  return "";
};
